import type { Breadcrumb } from "~/core/models/Breadcrumb.interface";
import { PATH_ABOUT } from "~/modules/about/constants";
import { PATH_LOGS } from "~/modules/auditLog/constants";
import { PATH_CAMPAIGNS } from "~/modules/campaign/constants";
import { PATH_PARAMETERS_CERTIFICATES_TRUSTSTORE } from "~/modules/certificate/constants";
import { PATH_DTWINS } from "~/modules/dtwin/constants";
import { PATH_PARAMETERS_FIRMWARES } from "~/modules/firmware/constants";
import { PATH_FLEETS } from "~/modules/fleet/constants";
import { PATH_PARAMETERS_GLOBAL_DEVICE_CONFIGURATION } from "~/modules/globalDeviceConfiguration/constants";
import { PATH_PARAMETERS_INTERFACES } from "~/modules/interface/constants";
import { PATH_PARAMETERS_LICENSE } from "~/modules/license/constants";
import { PATH_SECTORS } from "~/modules/sector/constants";
import {
  PATH_USER_ACCOUNT,
  PATH_USER_MANAGEMENT,
  PATH_USER_MANAGEMENT_GROUPS,
} from "~/modules/user/constants";
import { PATH_PARAMETERS_CONFIGURATIONS } from "~/modules/globalConfiguration/constants";

export const BREADCRUMBS: Record<string, Breadcrumb> = {
  ABOUT: {
    title: "page.about.title",
    href: PATH_ABOUT,
  },
  CAMPAIGN: {
    title: "page.campaigns.title",
    href: PATH_CAMPAIGNS,
  },
  DTWIN: {
    title: "page.dtwins.title",
    href: PATH_DTWINS,
  },
  DASHBOARD: {
    title: "page.dashboard.title",
    href: "/",
  },
  FIRMWARE: {
    title: "page.firmware.title",
    href: PATH_PARAMETERS_FIRMWARES,
  },
  FLEETS: {
    title: "page.fleets.title",
    href: PATH_FLEETS,
  },
  GLOBAL_CONFIGURATION: {
    title: "page.globalConfiguration.title",
    href: PATH_PARAMETERS_CONFIGURATIONS,
  },
  GLOBAL_DEVICE_CONFIGURATION: {
    title: "page.deviceConfiguration.title",
    href: PATH_PARAMETERS_GLOBAL_DEVICE_CONFIGURATION,
  },
  GROUP: {
    title: "page.userGroups.title",
    href: PATH_USER_MANAGEMENT_GROUPS,
  },
  INTERFACE: {
    title: "page.interfaces.title",
    href: PATH_PARAMETERS_INTERFACES,
  },
  LICENSE: {
    title: "page.license.title",
    href: PATH_PARAMETERS_LICENSE,
  },
  LOGS: {
    title: "page.logs.title",
    href: PATH_LOGS,
  },
  SECTOR: {
    title: "page.sectors.title",
    href: PATH_SECTORS,
  },
  TRUSTSTORE: {
    title: "page.truststore.title",
    href: PATH_PARAMETERS_CERTIFICATES_TRUSTSTORE,
  },
  USER_ACCOUNT: {
    title: "page.userAccount.title",
    href: PATH_USER_ACCOUNT,
  },
  USER_MANAGEMENT: {
    title: "page.users.title",
    href: PATH_USER_MANAGEMENT,
  },
};
